"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Query_1 = require("./Query");
var BaseEntityQuery_1 = require("./BaseEntityQuery");
var EntitiesQuery = /** @class */ (function (_super) {
    __extends(EntitiesQuery, _super);
    function EntitiesQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EntitiesQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, entityConditional = _a.entityConditional, entitiesOptions = _a.entitiesOptions, _b = _a.options, options = _b === void 0 ? {} : _b;
        var childQuery = (entitiesOptions || {}).childQuery;
        return __assign({ entityConditional: entityConditional,
            childQuery: childQuery }, (options.entities || {}));
    };
    EntitiesQuery.prototype.getRawValue = function (executionOptions) {
        var _a, _b;
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        var entities = this.getEntities(executionOptions, context);
        var results = [];
        if (entities && entities.length > 0) {
            var childQuery = this.options.childQuery;
            if (!childQuery) {
                // Default to return whole entity if no childQuery is defined.
                return entities;
            }
            var entitiesConfiguration = Query_1.Query.getContextConfiguration(executionOptions, this.queryOptions);
            var queryId_1 = this.queryOptions.queryId;
            var entityConfiguration = void 0;
            var linkedEntities = void 0;
            if (entitiesConfiguration) {
                entityConfiguration = entitiesConfiguration.entities.find(function (config) { return config.id === queryId_1; });
                linkedEntities = entityConfiguration && entityConfiguration.linkedEntities;
            }
            var options = childQuery;
            if (!childQuery.entityType) {
                var entityType = entities[0].type;
                options.entityType = entityType;
            }
            var query = new Query_1.Query(options, this.translationHelper);
            for (var _i = 0, entities_1 = entities; _i < entities_1.length; _i++) {
                var entity = entities_1[_i];
                var result = void 0;
                var overridingContext = {};
                var entityKey = options.entityKey;
                if (linkedEntities && entityKey) {
                    // Get the entityMap and entitiesById based on the base entity
                    var _c = context.entities[queryId_1], entityMap = _c.entityMap, entitiesById = _c.entitiesById;
                    var queryContextEntityMap = entityMap.get(entity.entityId);
                    // Add this entity data to the entitiesById map
                    entitiesById.set(entity.entityId, entity);
                    // Add this entityId to the entityMap
                    var entityId = new Set([entity.entityId]);
                    var overridingEntityMap = __assign(__assign({}, queryContextEntityMap), (_a = {}, _a[entityConfiguration.id] = entityId, _a));
                    overridingContext = {
                        entitiesById: entitiesById,
                        entityMap: overridingEntityMap,
                    };
                }
                else {
                    overridingContext = __assign(__assign({}, executionOptions.context), { entityByType: (_b = {},
                            _b[options.entityType] = entity,
                            _b) });
                }
                var workingExecutionOptions = __assign(__assign({}, executionOptions), { context: __assign({}, overridingContext) });
                result = query.execute(workingExecutionOptions);
                if (result) {
                    results.push(result);
                }
            }
        }
        return results;
    };
    return EntitiesQuery;
}(BaseEntityQuery_1.BaseEntityQuery));
exports.EntitiesQuery = EntitiesQuery;
//# sourceMappingURL=EntitiesQuery.js.map